import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';
import { MarginProps } from 'styled-system';

import { ActionButton } from '~/components/partials/ReceptionDrawer/ActionButton';
import { requestAppointmentModalState } from '~/state/reception/atoms';

export const RequestBookingButton = (props: MarginProps) => {
  const setModalState = useSetAtom(requestAppointmentModalState);
  const handleClick = useCallback(() => {
    setModalState({
      isOpen: true,
    });
  }, [setModalState]);

  return (
    <ActionButton use="primaryInverse" wide="fill" size="l" onClick={handleClick} {...props}>
      FAX等で処方箋を受領した
    </ActionButton>
  );
};
